/**
 * A React functional component that renders a depots management component.
 * It utilizes the react-i18next library for translation and the react-redux library for dispatching actions.
 * @returns The rendered depots management component.
 */
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { Helmet } from 'react-helmet';

import DepotsManagementComponent from "./depotsManagementComponent";


/**
 * Import the depot.json file from the API folder.
 * @returns The contents of the depot.json file.
 */
import { getDepotsList, addDepots, editDepots, depotsEditStatus, depotsDelete, editDepotsReduxState, editDepotsStatusReduxState, deleteDepotsReduxState } from "../../store/depots/actions";
import { debounce } from "lodash";
import useWindowDimension from "../../components/hooks/useWindowDimension";
import Constant from "../../util/constant";

/**
 * A container component for managing depots.
 * @param {{object}} props - The component props.
 * @returns The DepotsManagementContainer component.
 */
const DepotsManagementContainer = (props) => {
  const { t } = useTranslation();
  const dimensions = useWindowDimension();
  const dispatch = useDispatch();
  const depotList = useSelector((state) => state?.Depots?.depotsList?.data)
  const tableContainerRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const pageSizeRef = useRef(dimensions.width > 1920 ? 25 : 17);
  const smarttableref = useRef();
  const toggleDisable = useRef(false);
  const [iscreateDepotModelLoaderButton, setIscreateDepotModelLoaderButton] =
    useState(false);
    const [isUpdateDepotModelLoaderButton, setIsUpdateDepotModelLoaderButton] =
    useState(false);
    const [disableModelLoaderBotton, setDisableModelLoaderBotton] =
    useState(false);

  const [showCreateDepotModal, setShowCreateDepotModal] = useState(false);
  const [showDeleteUserModal, setshowDeleteUserModal] = useState(false);
  const [showUpdateDepotModal, setUpdateDepotModal] = useState(false);
  const [updatedepotValues, setUpdatedepotValues] = useState(null);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const [depottextcount, setDepottextcount] = useState(0);
  const [searchValue, setSearchValue] = useState(null);
  const [placeHolder, setPlaceHolder] = useState(true);
  const [depotValue, setDepotValue] = useState({ name: "", id: "" });    
  const [updatetextcount, setUpdatetextcount] = useState(depotValue?.length);

  const [tableFilterHeight, setTableFilterHeight] = useState("");
  const [breadcrumbHeight, setBreadcrumbHeight] = useState("");
  const [tabHeaderHeight, setTabHeaderHeight] = useState("");
  const [headerHeight, setHeaderHeight] = useState("");
  const [loaderHtml, setLoaderHtmlHeight] = useState("");
  const [loaderButtonShow, setLoaderButtonShow] = useState(false);
  const [issetupdateDepotValue,setIssetupdateDepotValue] = useState("");
  const [updateDepotValue,setUpdateDepotValue] = useState("");
  const [enableDisableID, setEnableDisableID] = useState("");
  const [createValues, setCreateValues] = useState(""); 
  const [searchedData, setSearchedData] = useState(depotList);
  useEffect(() => {
    setSearchedData(depotList)
  }, [depotList]);
  /**
   * Initializes the state variables for depot data, and sets their initial values based on the provided depot item data.
   * @param {{object}} depotItem - The depot item data.
   * @returns None
   */
  const depotLength = depotList?.length;
  const mangerLength = depotList?.map((item) => item?.noofmanagers);
  const driverLength = depotList?.map((item) => item?.noofdrivers);
  

  /**
   * A React hook that manages a boolean state value and updates it after a specified delay.
   * @returns None
   */
  useEffect(() => {
 
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Updates the heights of various elements on the page when the loading state changes.
   * @param {{boolean}} loading - The loading state of the page.
   * @returns None
   */
  useEffect(() => {
    loading &&
      setLoaderHtmlHeight(
        document.getElementsByClassName("infinate-load")[0].offsetHeight
      );
    setHeaderHeight(
      document.getElementsByClassName("navbar-header")[0].offsetHeight
    );
    setBreadcrumbHeight(
      document.getElementsByClassName("page-title-box")[0].offsetHeight
    );
    setTableFilterHeight(
      document.getElementsByClassName("col-form-label")[0].offsetHeight
    );
    setTabHeaderHeight(document.getElementsByTagName("thead")[0].offsetHeight);
  }, [loading]);


  /**
   * Opens the delete user modal for the specified item.
   * @param {Event} e - The event object.
   * @param {Object} item - The item to be deleted.
   * @returns None
   */
  const openDeleteUserModal = (e, item) => {
    setDeleteId(item?.depotid);
    setshowDeleteUserModal(true);
  };

  /**
   * Retrieves a list of depots using an API call and sets the depot data state.
   * @returns None
   */
  const getList = () => {
    dispatch(getDepotsList( {}, (res) => {
        if (res) {
         setPlaceHolder(false);
       }
    }, (err) => {  console.log(err); }))
  }


  const searchFilterClear = () => {
    smarttableref.current.querySelectorAll("button")[1].click();
  };
  useEffect(() => {
    
  }, [searchedData]);
  // const onTableFilterChange = (filterText) => {
  //   setSearchValue(filterText);
  // }
  const onTableFilterChange = (value) => {
    setSearchValue(value);
  
    // Filter the data based on the search value
    const filteredData = depotList?.filter(item =>
      item?.name?.toLowerCase()?.includes(value.toLowerCase()) ||
      item?.depotstatus?.toLowerCase()?.includes(value.toLowerCase()) ||
      item?.noofdrivers?.toString()?.includes(value.toLowerCase()) ||
      item?.noofmanagers?.toString()?.includes(value.toLowerCase())
    );
  
    // Update the state with the filtered data
    setSearchedData(filteredData);
  };
  

  /**
   * Handles the form submission by dispatching an action to add a depot with the provided data.
   * @param {{object}} data - The form data containing the depot name.
   * @returns None
   */
  const handleFormSubmit = (data) => {
    setIscreateDepotModelLoaderButton(true);
    const params = {
      name: data?.Depotname
    }
    dispatch(addDepots(params, (res) => {
      setDepottextcount(0);
      getList();
      setShowCreateDepotModal(false);
      setIscreateDepotModelLoaderButton(false);
    }, (err) => {setIscreateDepotModelLoaderButton(false); console.log(err);  }))
    setLoaderButtonShow(false);
  }

  /**
   * Handles the form submission for updating a depot.
   * @param {{object}} data - The data from the form submission.
   * @returns None
   */
  const handleUpdateFormSubmit = (data) => {
   
    setIsUpdateDepotModelLoaderButton(true)
    const params = {
      name: data?.Depotname
    }
    dispatch(editDepots(depotValue?.id, params, (res) => {
      setUpdatetextcount(0)
      if (res) {
        const _upatedList = depotList?.map((item) => {
          if (item?.depotid === depotValue?.id) {
            
            return { ...item, name: data?.Depotname }
          }
          return item;
        })
        dispatch(editDepotsReduxState(_upatedList))
        setIsUpdateDepotModelLoaderButton(false)
      }
    }, (err) => {setIsUpdateDepotModelLoaderButton(false); console.log(err); }))
  }
  /**
   * Defines an array of column objects for a table component.
   * Each column object represents a column in the table and contains properties such as label, key, filter, and sorting.
   * @returns {Array} An array of column objects.
   */
  const columns = [
    {
      label: (
        <>
          {t("DEPOT_NAME")} <span className="thCount">{depotLength}</span>
        </>
      ),
      key: "name",
      filter: false,
      sorter: true,
    },
    {
      label: (
        <>
          {t("NO_OF_MANAGER")} <span className="thCount">{_.sum(mangerLength)}</span>
        </>
      ),
      key: "noofmanagers",
      filter: false,
      sorter: false,
    },
    {
      label: (
        <>
          {t("NO_OF_DRIVER")} <span className="thCount">{_.sum(driverLength)}</span>
        </>
      ),
      key: "noofdrivers",
      filter: false,
      sorter: false,
    },
    {
      label: "Actions",
      key: "depotstatus",
      filter: false,
      sorter: false,
    },
  ];

  /**
   * Closes the delete user modal by setting the state of `showDeleteUserModal` to false.
   * @returns None
   */
  const closeDeleteUserModal = () => setshowDeleteUserModal(false);
  const closeDeactivateModal = () => setShowStatusModal(false);

  /**
   * Executes a function after a delay of 1000 milliseconds using setTimeout.
   * The function dispatches a toast message with a success type and a message
   * indicating that the depot has been deleted successfully. It then closes
   * the delete user modal.
   * @returns None
   */
  const onDeleteUser = () => {
    dispatch(depotsDelete(deleteId, (res) => {
      if (res) {
        dispatch(deleteDepotsReduxState(depotList?.filter((item) => item?.depotid !== deleteId)))
      }
    }, (err) => { console.log(err); }))
    closeDeleteUserModal();
  };

  /**
   * Handles the action when a check is performed on an item.
   * @param {{Event}} e - The event object.
   * @param {{Item}} item - The item being checked.
   * @returns None
   */
  const onCheckAction = (e, item) => {
    setEnableDisableID(item)
    const status = item?.depotstatus;
    if (status === Constant.GENERALKEYS.ACTIVE) {
      setShowStatusModal(true);
    } else {
      onActive(e, item?.depotid);
    }
  };

  /**
   * Updates the status of a depot to "deactive" and displays a success toast message.
   * @returns None
   */
  const onDeactivate = () => {
    setDisableModelLoaderBotton(true);
    const params = {
      depotstatus: Constant.GENERALKEYS.INACTIVE
    }
    dispatch(depotsEditStatus(enableDisableID?.depotid, params, (res) => {
      if (res) {
        const _upatedList = depotList?.map((item) => {
          if (item?.depotid === enableDisableID?.depotid) {
            return { ...item, depotstatus: Constant.GENERALKEYS.INACTIVE }
          }
          return item;
        })
        dispatch(editDepotsStatusReduxState(_upatedList))
      }
      setShowStatusModal(false);
      setDisableModelLoaderBotton(false);
    }, (err) => {setDisableModelLoaderBotton(false);  console.log(err); }))

  };

  /**
   * Updates the status of a depot to "Active" and displays a success toast message.
   * @param {Event} e - The event object.
   * @param {string} id - The ID of the depot to update.
   * @returns None
   */
  const onActive = (e, id) => {
    const params = {
      depotstatus: Constant.GENERALKEYS.ACTIVE
    }
    if (!toggleDisable.current) {
      toggleDisable.current = true

      dispatch(depotsEditStatus(id, params, (res) => {
        if (res) {
          const _upatedList = depotList?.map((item) => {
            if (item?.depotid === id) {
              return { ...item, depotstatus: Constant.GENERALKEYS.ACTIVE }
            }
            return item;
          })
          dispatch(editDepotsStatusReduxState(_upatedList))
          toggleDisable.current = false
        }
      }, (err) => { 
        toggleDisable.current = false
        console.log(err); 
      }))

    }
  };

  const clearSearchButton = () => {
    smarttableref.current.querySelectorAll("button")[0].click();
  };

  /**
   * Opens the create depot modal.
   * @returns None
   */
  const openCreateDepotModal = () => {
    setShowCreateDepotModal(true);
  };

  /**
   * Closes the create depot modal by setting the state of `showCreateDepotModal` to false.
   * @returns None
   */
  const closeCreateDepotModal = () => {
    setShowCreateDepotModal(false);
    setDepottextcount(0); 
  };

  /**
   * Closes the update depot modal by setting the state of `updateDepotModal` to `false`.
   * @returns None
   */
  const closeUpdateDepotModal = () => {
    setUpdateDepotModal(false);
    setUpdatetextcount(0)
  };

  /**
   * Updates the depot values with the provided form data.
   * @param {{object}} form - The form data to update the depot values with.
   * @returns None
   */
  const updateDepotFunction = (form) => {
    
    setUpdatedepotValues(form);
  };
  /**
   * Clears the update data by resetting the values of the updatedepotValues object.
   * @returns None
   */
  const clearUpdateData = () => {
    setUpdatetextcount(0)
    updatedepotValues?.reset({
      Depotname: "",
    });
  };

  /**
   * Executes a side effect when the dependencies change. If the `updatedepotValues` is not null,
   * it updates the value of "Depotname" in `updatedepotValues` with the value of `depotValue`.
   * @param {{Function}} updatedepotValues - The function to update the depot values.
   * @param {{any}} depotValue - The new value for "Depotname".
   * @returns None
   */
  useEffect(() => {
    if (updatedepotValues !== null) {
      updatedepotValues?.setValue("Depotname", depotValue?.name, {
        shouldValidate: true,
      });
    }
  }, [updatedepotValues, depotValue]);

  /**
   * Handles the update of a depot when triggered by an event.
   * @param {Event} e - The event that triggered the update.
   * @param {Item} item - The item to update the depot with.
   * @returns None
   */
  const onUpdateDepot = (e, item) => {
    setIssetupdateDepotValue(item?.name)
    setDepotValue({ name: item?.name, id: item?.depotid, depotstatus: item?.depotstatus, noofdrivers: item?.noofdrivers, noofmanagers: item?.noofmanagers });
    setUpdateDepotModal(true);
    setUpdatetextcount(item?.name?.length)
  };

  /**
   * Updates the depot with the given item and displays a success toast message.
   * @param {Event} e - The event object.
   * @param {any} item - The item to update the depot with.
   * @returns None
   */
  const updateDepotFun = (e, item) => {
    
   setUpdateDepotModal(false);
  };
  const handledepottextChange = (e) => {
    const value = e.target.value;
    setDepottextcount(value.length);
  };
  const handleupdatetextChange = (e) => {
    const value = e.target.value;
    setUpdatetextcount(value.length);
  };

  const clearCreatData = () => {
    setDepottextcount(0);
    createValues.reset({
      Depotname: "",
    });
  };

  const createDepotFunction = (form) => {
    setCreateValues(form);
  };


  /**
   * Loads more items when triggered, with a delay of 1 second.
   * @returns None
   */
  const loadMoreItems = () => {
    if (loading) return;
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      pageSizeRef.current += 10;
    }, 1000);
  };

  /**
   * Debounces the handleTableScroll function to prevent excessive calls.
   * When the table container is scrolled, it checks if the scroll position is at the bottom
   * and if there are more items to load. If both conditions are met, it calls the loadMoreItems function.
   * @returns None
   */
  const handleTableScroll = debounce(() => {
    const tableContainer = tableContainerRef?.current;
    if (tableContainer) {
      const isAtBottom =
        tableContainer?.scrollTop + tableContainer?.clientHeight >=
        tableContainer?.scrollHeight;
      if (isAtBottom && depotList?.length > pageSizeRef?.current) {
        loadMoreItems();
      }
    }
  }, 200);

  /**
   * Adds an event listener to the table container element to handle scroll events.
   * The event listener is removed when the component is unmounted.
   * @param {Function} handleTableScroll - The function to handle the table scroll event.
   * @returns None
   */
  useEffect(() => {
    const tableContainer = tableContainerRef?.current;
    if (tableContainer) {
      tableContainer?.addEventListener("scroll", handleTableScroll);
    }
    return () => {
      if (tableContainer) {
        tableContainer?.removeEventListener("scroll", handleTableScroll);
      }
    };
  }, [handleTableScroll]);


  
  /**
   * Renders a component with various props passed to it.
   * @param {{CreateDepotFun}} CreateDepotFun - The function to create a depot.
   * @param {{boolean}} showCreateDepotModal - Whether or not to show the create depot modal.
   * @param {{function}} openCreateDepotModal - The function to open the create depot modal.
   * @param {{function}} updateDepotFun - The function to update a depot.
   * @param {{boolean}} showDeleteUserModal - Whether or not to show the delete user modal.
   * @param {{function}} openDeleteUserModal - The function to open the delete user modal.
   * @param {{function}} closeDeleteUserModal - The function to close
   */
  return (

    <>
    <Helmet>
      <title>Depot Management | ScotRail Safety Notice Portal</title>
    </Helmet>
    <DepotsManagementComponent
      showCreateDepotModal={showCreateDepotModal}
      openCreateDepotModal={openCreateDepotModal}
      updateDepotFun={(e, item) => {
        updateDepotFun(e, item);
      }}
      breadcrumbMainTitle={true}
      showDeleteUserModal={showDeleteUserModal}
      openDeleteUserModal={(e, item) => {
        openDeleteUserModal(e, item);
      }}
      closeDeleteUserModal={closeDeleteUserModal}
      onDeleteUser={onDeleteUser}
      onProcced={onDeactivate}
      columns={columns}
      depotData={depotList}
      clearSearchButton={clearSearchButton}
      showStatusModal={showStatusModal}
      noDataFound={t("NO_DATA_FOUND")}
      noDataTitle={t("NO_RESULT_FOUND")}
      noDataDesc={t(
        "YOUR_SEARCH_DID_NOT_MATCH_ANY_DEPOTS_PLEASE_TRY_SEARCHING_AGAIN"
      )}
      noDataAddButtonTitle={t("CREATE_DEPOTS")}
      onCheckAction={(e, item) => onCheckAction(e, item)}
      closeDeactiveModal={closeDeactivateModal}
      onUpdateDepot={(e, item) => onUpdateDepot(e, item)}
      showUpdateDepotModal={showUpdateDepotModal}
      closeUpdateDepotModal={closeUpdateDepotModal}
      closeCreateDepotModal={closeCreateDepotModal}
      emptyDataAddButton={openCreateDepotModal}
      placeHolderShimer={placeHolder}
      clearUpdateData={clearUpdateData}
      updateDepotFunction={(form) => {
        updateDepotFunction(form);
      }}
      handleFormSubmit={(e) => { handleFormSubmit(e) }}
      handleUpdateFormSubmit={(e) => { handleUpdateFormSubmit(e) }}
      loadingbutton={loaderButtonShow}
      tableFilterHeight={tableFilterHeight}
      breadcrumbHeight={breadcrumbHeight}
      tabHeaderHeight={tabHeaderHeight}
      headerHeight={headerHeight}
      smarttableref={smarttableref}
      loaderHtml={loaderHtml}
      loadingscroll={loading}
      itemsPerPage={pageSizeRef.current}  
      dimensions={dimensions}
      tableContainerRef={tableContainerRef}

      createDepotModelLoaderButton={iscreateDepotModelLoaderButton}
      updateDepotModelLoaderButton={isUpdateDepotModelLoaderButton}
      disableModelLoaderBotton={disableModelLoaderBotton}
      updateDepotsValue={updateDepotValue}
      issetupdateDepotValue={issetupdateDepotValue}
      setUpdateDepotValue={(e)=> {setUpdateDepotValue(e.target.value);}}
      searchFilterClear={searchFilterClear}
      searchValue={searchValue}
      onTableFilterChange={onTableFilterChange}
      handledepottextChange={handledepottextChange}
      depottextcount={depottextcount}
      clearCreatData={clearCreatData}
      createValues={createValues}
      createDepotFunction={createDepotFunction}
      updatetextcount={updatetextcount}
      handleupdatetextChange={handleupdatetextChange}
      searchedData={searchedData}
    />
    </>
  );
};

export default DepotsManagementContainer;
